<template>
    <div>
        <el-card class="box-card">
            <div class="text item">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form :inline="true" class="demo-form-inline" size="small"
                                style="text-align: left;margin-top:5px;height:30px" ref="Searchform" :model="Search">
                                <el-form-item label="用户昵称" prop="jp_nick_name">
                                    <el-input v-model="Search.jp_nick_name" placeholder="请输入用户昵称" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="手机号" prop="jp_phone">
                                    <el-input v-model="Search.jp_phone" placeholder="请输入用户手机号码" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="真实姓名" prop="jp_name">
                                    <el-input v-model="Search.jp_name" placeholder="请输入真实姓名" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="身份" prop="jp_role">
                                    <el-select v-model="Search.jp_role" placeholder="请选择用户权限">
                                        <el-option v-for="item in role_options" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" size="mini"
                                        @click="getCampusParttimeList()">查询</el-button>
                                    <el-button icon="el-icon-refresh" size="mini" @click="ClearSearchform()">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple-light">
                            <el-table 
                                :data="tableData_parttime" 
                                border 
                                style="width: 100%"
                                max-height="600"
                                :default-sort="{ prop: 'createTime', order: 'descending' }">
                                <el-table-column prop="jpPortrait" label="用户头像" width="90" align="center">
                                    <template slot-scope="scope">
                                        <el-avatar :size="40" :src="scope.row.jpPortrait" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="jpNickName" label="用户昵称" width="120" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="jpPhone" label="手机号码" width="120">
                                </el-table-column>
                                <el-table-column prop="jobName" label="真实姓名" width="100">
                                </el-table-column>
                                <el-table-column prop="studentPapers" label="学生证" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-image style="height:50px" mode="heightFix"
                                            :preview-src-list=[scope.row.studentPapers] :src="scope.row.studentPapers"
                                            ></el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="idCard" label="身份证" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-image style="height:50px" mode="heightFix"
                                            :preview-src-list=[scope.row.studentPapers] :src="scope.row.idCard"
                                            ></el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="schoolName" label="所属学校" min-width="150" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="jobType" label="兼职类型" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.jobType == 'C'" size="small">兼职</el-tag>
                                        <el-tag v-if="scope.row.jobType == 'F'" type="warning" size="small">负责人</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="jobParentName" label="所属团队" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.jobParentId != 0">{{ scope.row.jobParentName }}</span>
                                        <span v-else style="color: #999;">无</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="createTime" label="申请时间" width="180" sortable>
                                    <template slot-scope="scope">
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{ scope.row.createTime | dateFormat }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="兼职状态" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.status" active-color="#13ce66"
                                            inactive-color="#ff4949" active-value="1" inactive-value="2"></el-switch>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-search" size="mini"
                                            @click="toUpdate(scope.row)">修改</el-button>
                                        <el-button type="danger" icon="el-icon-delete" size="mini"
                                            @click="toDelete(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="24">
                        <div style="text-align: center;">
                            <el-pagination 
                                v-if="tableData_parttime.length != 0"
                                background 
                                layout="total, prev, pager, next, jumper" 
                                :total="total" 
                                :current-page="queryObj.page"
                                :page-size="queryObj.limit"
                                @size-change="handleSizeChange" 
                                @current-change="handleSizeChange">
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <!-- 修改对话框 -->
        <el-dialog title="修 改" :visible.sync="Update_dialog" width="70%" :before-close="handleClose" center>
            <el-descriptions title="注册信息" :column="3" border>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        用户昵称
                    </template>
                    {{ Updateform.jpNickName }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        手机号
                    </template>
                    {{ Updateform.jpPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        身份
                    </template>
                    <el-select v-model="Updateform.jobType" placeholder="请选择身份" size="small" style="width: 140px;" @change="onJobTypeChange">
                        <el-option label="兼职" value="C"></el-option>
                        <el-option label="负责人" value="F"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item v-if="Updateform.jobType === 'F'" :span="3">
                    <template slot="label">
                        <i class="el-icon-postcard"></i>
                        我的邀请码
                    </template>
                    <span v-if="Updateform.resCode" class="invite-code-text">{{ Updateform.resCode }}</span>
                    <span v-else class="invite-code-empty">审核通过后由系统生成</span>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions title="实名信息" style="margin-top:20px;"></el-descriptions>

            <el-form ref="updateform" :model="Updateform" :rules="rules" inline label-width="80px">
                <el-form-item label="真实姓名" prop="jobName" :rules="rules">
                    <el-input v-model="Updateform.jobName"></el-input>
                </el-form-item>
                <el-form-item label="所属学校" prop="schoolId" :rules="rules">
                    <el-select v-model="Updateform.schoolId" filterable remote placeholder="请输入学校关键词"
                        :remote-method="getSchoolBySchoolName" :loading="loading"
                        @change="onSchoolChange">
                        <el-option v-for="item in school_options" :key="item.schoolId" :label="item.schoolName"
                            :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属团队" prop="jobParentId" v-if="Updateform.jobType !== 'F'">
                    <el-select v-model="Updateform.jobParentId" filterable remote placeholder="请输入负责人姓名,无则留空"
                        :remote-method="getTeamByJobName" :loading="loading">
                        <el-option v-for="item in team_options" :key="item.campusUserId" :label="item.jobName"
                            :value="item.campusUserId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <!-- <span>这是一段信息</span> -->
            <span slot="footer" class="dialog-footer">
                <el-button icon="el-icon-close" type="danger" @click="Update_dialog = false">取 消</el-button>
                <el-button icon="el-icon-check" type="success" @click="UpdateCampusUser()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            // 权限选择
            role_options: [{
                value: '1',
                label: '负责人'
            }, {
                value: '2',
                label: '兼职'
            }],
            school_options: [],//学校下拉列表
            team_options: [{
                campusUserId: 0,
                jobName: "无"
            }],//所属团队下拉列表
            //验证规则
            rules:
                [
                    { required: true, message: "请输入内容", trigger: 'blur' },
                    { pattern: !/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi, message: "请输入合法字符", trigger: "blur" }
                ]
            ,
            Search: {//搜索内容
                jp_nick_name: '',
                jp_phone: '',
                jp_name: '',
                jp_role: ''
            },
            total: 0,//分页总条目
            tableData_parttime: [],//表格数据(小程序兼职和负责人)
            loading: false,//搜索加载
            queryObj: {//分页渲染条件
                limit: 8,//行
                page: 1,//页数
                query: "",//条件
            },
            Update_dialog: false,//修改对话框
            Updateform: {},//修改对象

        };
    },
    watch: {},
    computed: {},
    methods: {
        // 确认修改
        async UpdateCampusUser() {
            console.log(this.Updateform);
            const { data: res } = await this.$http.post('campusjob/updateCampusJob', this.Updateform);
            if (res.code == 200) {
                this.$message({ type: "success", message: "修改成功！" })
                this.getCampusParttimeList()
            } else {
                this.$message({ type: "error", message: "修改失败！" })
                this.getCampusParttimeList()
            }
            this.Update_dialog = false
        },
        // 团队下拉搜索
        async getTeamByJobName(query) {
            // 如果有学校ID，就加载负责人列表（无论query是否为空）
            if (this.Updateform.schoolId) {
                this.school_loading = true;
                const { data: res } = await this.$http.get('/campusjob/getTeamByJobName',
                    {
                        params: { 
                            jobName: query || '',
                            schoolId: this.Updateform.schoolId
                        }
                    });
                console.log('团队下拉列表数据:', res)
                setTimeout(() => {
                    this.loading = false;
                    // 始终在列表开头添加"无"选项
                    this.team_options = [
                        { id: 0, jobName: '无', campusUserId: 0 },
                        ...res.data
                    ];
                }, 200);
            } else {
                // 如果没有学校ID，只显示"无"选项
                this.team_options = [{ id: 0, jobName: '无', campusUserId: 0 }];
            }
        },
        // 学校下拉搜索
        async getSchoolBySchoolName(query) {
            if (query !== '') {
                this.school_loading = true;
                const { data: res } = await this.$http.get('/school/getSchoolBySchoolName',
                    {
                        params: { schoolName: query }
                    });
                // console.log(res)
                setTimeout(() => {
                    this.loading = false;
                    this.school_options = res.data
                }, 200);
            } else {
                this.school_options = [];
            }
        },
        // 身份切换：负责人无所属团队，切换时清空所属团队
        onJobTypeChange(newJobType) {
            if (newJobType === 'F') {
                this.Updateform.jobParentId = 0;
                this.Updateform.jobParentName = '无';
            }
        },
        // 学校改变时的处理
        onSchoolChange(newSchoolId) {
            console.log('学校已改变，新的学校ID:', newSchoolId);
            // 重置所属团队为"无"
            this.Updateform.jobParentId = 0;
            this.Updateform.jobParentName = '无';
            
            // 重新加载新学校的负责人列表（如果是兼职的话）
            if (this.Updateform.jobType !== 'F') {
                this.team_options = [{ campusUserId: 0, jobName: '无' }];
                // 自动加载新学校的所有负责人
                this.getTeamByJobName('');
            }
            
            this.$message({
                type: 'warning',
                message: '学校已修改，所属团队已重置为"无"，如需挂靠到新学校的团队，请重新选择',
                duration: 3000
            });
        },
        //分页交互调用事件
        handleSizeChange(newPage) {
            this.queryObj.page = newPage;
            this.getCampusParttimeList();
        },
        // 对话框关闭
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        // 点击修改
        toUpdate(Data) {
            this.Updateform = JSON.parse(JSON.stringify(Data));
            console.log('修改的数据:', this.Updateform);
            this.getSchoolBySchoolName(this.Updateform.schoolName)
            // 如果是兼职(非负责人)，则初始化所属团队下拉列表
            if (this.Updateform.jobType !== 'F') {
                // 初始化"无"选项
                this.team_options = [{ campusUserId: 0, jobName: '无' }];
                // 加载该学校的所有负责人（如果有负责人姓名就搜索，否则加载全部）
                if (this.Updateform.jobParentId != 0 && this.Updateform.jobParentName) {
                    this.getTeamByJobName(this.Updateform.jobParentName)
                } else {
                    this.getTeamByJobName(''); // 加载该学校所有负责人
                }
            }
            this.Update_dialog = true;
        },
        // 拼接字符串条件
        Query(Str) {
            for (var key in Str) {
                if (Str[key] == '' || Str[key] == null) {
                    delete Str[key]
                }
            }
            let str = JSON.stringify(Str).replace(/(\{")/g, "").replace(/(\":)/g, ' like ').replace(/}/g, '').replace(/,"/g, ' and ').replace(/{/g, '').replace(/"/g, '%"').replace('like %"', 'like "%');
            return str
        },
        // 重新渲染表格
        // 渲染表格数据(动态)数据
        async getCampusParttimeList() {
            let str = this.Query(this.Search);
            console.log(str.length);
            console.log(str);
            this.queryObj.query = str
            const { data: res } = await this.$http.get('/campusjob/getParttimeList',
                {
                    params: this.queryObj
                });
            console.log(res)
            this.tableData_parttime = res.data.children;
            this.total = res.data.total;
        },

        // 点击删除
        toDelete(Data) {
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.post('campusjob/delCompusParttime', { id: Data.id, userId: Data.campusUserId });
                if (res.code == 200) {
                    this.$message({ type: "success", message: "删除成功!" })
                    this.getCampusParttimeList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 重置搜索表单
        ClearSearchform() {
            console.log("重置搜索表单");
            this.$refs.Searchform.resetFields()
        },
    },
    created() { },
    mounted() {
        this.getCampusParttimeList()
    }
};
</script>
<style scoped>
.box-card {
    width: 100%;
}

.item {
    margin-bottom: 18px;
}

.grid-content {
    margin: 20px 0;
}
.invite-code-text {
    font-weight: 600;
    color: #00C2A8;
    font-size: 16px;
    letter-spacing: 2px;
}
.invite-code-empty {
    color: #909399;
    font-size: 13px;
}
</style>